// extracted by mini-css-extract-plugin
module.exports = {"conFirmSendStyle":"_2UG0vLP6-WKRAwHXBoipu9"};